module.exports = __webpack_public_path__ + "img/dish.a447a6f7.svg";